const Welcome = () => import('~/pages/welcome').then(m => m.default || m)
const Login = () => import('~/pages/auth/login').then(m => m.default || m)
const Register = () => import('~/pages/auth/register').then(m => m.default || m)
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)
const Verify = () => import('~/pages/auth/email/verify').then(m => m.default || m)

const Home = () => import('~/pages/home').then(m => m.default || m)
const Settings = () => import('~/pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('~/pages/settings/profile').then(m => m.default || m)
const SettingsHotel = () => import('~/pages/settings/hotel').then(m => m.default || m)
const SettingsSettings = () => import('~/pages/settings/settings').then(m => m.default || m)
const SettingsSql = () => import('~/pages/settings/sql').then(m => m.default || m)
const SettingsPassword = () => import('~/pages/settings/password').then(m => m.default || m)
const Add = () => import('~/pages/add').then(m => m.default || m)
const Furniture = () => import('~/pages/furniture').then(m => m.default || m)
const Public = () => import('~/pages/public').then(m => m.default || m)
const News = () => import('~/pages/news').then(m => m.default || m)

const Furni = () => import('~/pages/furniture/index').then(m => m.default || m)

const Colors = () => import('~/pages/furniture/colors').then(m => m.default || m)
const SettingsFurni = () => import('~/pages/furniture/settings').then(m => m.default || m)
const Animations = () => import('~/pages/furniture/animations').then(m => m.default || m)
const Layers = () => import('~/pages/furniture/layers').then(m => m.default || m)
const Images = () => import('~/pages/furniture/images').then(m => m.default || m)
const Positions = () => import('~/pages/furniture/positions').then(m => m.default || m)
const Preview = () => import('~/pages/furniture/preview').then(m => m.default || m)
const Directions = () => import('~/pages/furniture/directions').then(m => m.default || m)

const Profile = () => import('~/pages/profile/index').then(m => m.default || m)
const ProfileFurniture = () => import('~/pages/profile/furniture').then(m => m.default || m)

const AddNews = () => import('~/pages/admin/addnews').then(m => m.default || m)
const Admin = () => import('~/pages/admin/admin').then(m => m.default || m)

const Premium = () => import('~/pages/premium').then(m => m.default || m)

export default [
  { path: '/', name: 'welcome', component: Welcome },

  { path: '/login', name: 'login', component: Login },
  { path: '/register', name: 'register', component: Register },
  { path: '/password/reset', name: 'password.request', component: PasswordEmail },
  { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset },
  { path: '/email/verify/:token', name: 'verify', component: Verify },

  { path: '/home', name: 'home', component: Home },
  { path: '/settings',
    component: Settings,
    children: [
      { path: '', redirect: { name: 'settings.profile' } },
      { path: 'profile', name: 'settings.profile', component: SettingsProfile },
      { path: 'hotel', name: 'settings.hotel', component: SettingsHotel },
      { path: 'settings', name: 'settings.settings', component: SettingsSettings },
      { path: 'sqlsettings', name: 'settings.sqlsettings', component: SettingsSql },
      { path: 'password', name: 'settings.password', component: SettingsPassword }
    ] },
  { path: '/add', name: 'add', component: Add },
  { path: '/furniture', redirect: { name: 'furniture', params: { page: 1 } } },
  { path: '/furniture/:page', name: 'furniture', component: Furniture },
  { path: '/public', redirect: { name: 'public', params: { page: 1 } } },
  { path: '/public/:page', name: 'public', component: Public },
  { path: '/news', redirect: { name: 'news', params: { page: 1 } } },
  { path: '/news/:page', name: 'news', component: News },
  { path: '/furni',
    component: Furni,
    children: [
      { path: 'colors/:furniture', name: 'colors', component: Colors },
      { path: 'settings/:furniture', name: 'settingsfurni', component: SettingsFurni },
      { path: 'animations/:furniture', name: 'animations', component: Animations },
      { path: 'layers/:furniture', name: 'layers', component: Layers },
      { path: 'images/:furniture', name: 'images', component: Images },
      { path: 'positions/:furniture', name: 'positions', component: Positions },
      { path: 'preview/:furniture', name: 'preview', component: Preview },
      { path: 'directions/:furniture', name: 'directions', component: Directions },
    ]
  },
  { path: '/profile',
    component: Profile,
    children: [
      { path: ':user_id', redirect: '/profile/:user_id/furniture/1' },
      { path: ':user_id/furniture', redirect: '/profile/:user_id/furniture/1' },
      { path: ':user_id/furniture/:page', name: 'profile.furniture', component: ProfileFurniture },
    ]
  },

  { path: '/addnews', name: 'addnews', component: AddNews },
  { path: '/admin', redirect: { name: 'admin', params: { page: 1 } } },
  { path: '/admin/:page', name: 'admin', component: Admin },

  { path: '/premium', redirect: { name: 'premium', params: { page: 1 } } },
  { path: '/premium/:page', name: 'premium', component: Premium },

  { path: '*', component: NotFound }
]



// WEBPACK FOOTER //
// ./resources/js/router/routes.js